import { Type } from '@angular/core';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

interface AugmentedType extends Type<any> {
    $name: string;
}

export class AngularUpgradeHelper {
    /**
     * Quickly downgrade a group of components
     * @param moduleName An AngularJS module name. Must be already created.
     * @param components The array of components
     */
    public static downgradeComponents(moduleName: string, components: AugmentedType[]) {
        components.forEach(component => {
            angular.module(moduleName).directive(component.$name, downgradeComponent({ component: component }));
        });
    }

    public static downgradeFactories(moduleName: string, factories: AugmentedType[]) {
        factories.forEach(factory => {
            angular.module(moduleName).factory(factory.$name, downgradeInjectable(factory));
        });
    }

    public static downgradeServices(moduleName: string, services: AugmentedType[]) {
        services.forEach(service => {
            angular.module(moduleName)
                .service(service.$name, downgradeInjectable(service));
        });
    }
}
